/**
 * Policy password lato frontend. Il backend non applica (volutamente, per
 * ora) queste regole: la validazione vive solo qui, quindi va tenuta
 * aggiornata con attenzione se in futuro si aggiunge anche un controllo
 * server-side.
 */
export interface PasswordRequirement {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: 'length',
    label: `Almeno ${PASSWORD_MIN_LENGTH} caratteri`,
    test: password => password.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: 'uppercase',
    label: 'Almeno una lettera maiuscola (A-Z)',
    test: password => /[A-Z]/.test(password),
  },
  {
    id: 'lowercase',
    label: 'Almeno una lettera minuscola (a-z)',
    test: password => /[a-z]/.test(password),
  },
  {
    id: 'number',
    label: 'Almeno un numero (0-9)',
    test: password => /[0-9]/.test(password),
  },
  {
    id: 'special',
    label: 'Almeno un carattere speciale (es. ! ? # % & *)',
    test: password => /[^A-Za-z0-9]/.test(password),
  },
];

export interface PasswordValidationResult {
  valid: boolean;
  failedRequirements: PasswordRequirement[];
}

export const validatePassword = (password: string): PasswordValidationResult => {
  const failedRequirements = PASSWORD_REQUIREMENTS.filter(req => !req.test(password));
  return { valid: failedRequirements.length === 0, failedRequirements };
};

/**
 * Messaggio pronto per un toast/alert che elenca in modo puntuale i
 * requisiti mancanti, così l'utente sa esattamente cosa correggere.
 */
export const describeMissingRequirements = (password: string): string | null => {
  const { valid, failedRequirements } = validatePassword(password);
  if (valid) return null;
  return `La password non rispetta questi requisiti: ${failedRequirements
    .map(r => r.label.toLowerCase())
    .join('; ')}.`;
};
